import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../../helpers/reselectHelpers';
import {ChannelTypesEnum} from '../../../../../../models/api/channelCommonTypes';
import {LoadedMessageModel} from '../../../../../../models/api/messageModel';
import {getUserParticipatingChannels} from '../../../../../../store/data/channels/channelsSelectors';
import {retweetAsyncAction} from '../../../../../../store/data/conversations/retweetActions';
import {toggleTweetIsLikedAsyncAction} from '../../../../../../store/data/conversations/toggleTweetIsLikedActions';
import {MessageViewerTweet} from './messageViewerTweet';

/*
 * Props.
 */

interface MessageViewerTweetContainerProps {
  message: LoadedMessageModel;
}

/*
 * Selectors.
 */

function makeGetTwitterChannels() {
  return createSelector(getUserParticipatingChannels, (participatingChannels) =>
    participatingChannels.filter((c) => c.type === ChannelTypesEnum.TWITTER),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<MessageViewerTweetContainerProps>()(() => ({
  twitterChannels: makeGetTwitterChannels(),
}));

const mapDispatchToProps = makeMapDispatchToProps<MessageViewerTweetContainerProps>()(({message}) => ({
  onRetweetClick: (channelId: number) => retweetAsyncAction(message.uid, channelId),
  onToggleLikeClick: () => toggleTweetIsLikedAsyncAction(message.uid),
}));

export const MessageViewerTweetContainer = connect(mapStateToProps, mapDispatchToProps)(MessageViewerTweet);
